(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("versionManager", VersionManagerService);

    VersionManagerService.$inject = ['$q', '$timeout', '$state', 'hUser', 'brandServices'];

    function VersionManagerService($q, $timeout, $state, hUser, brandServices) {
        var self = this;
        var _currentActiveVersion;
        var _lastCheck = 0;
        var _checkFrequency = 10 * 60 * 1000; // 10 minutes.
        var _checkTimerPromise;
        let initialized = false;
        let lastEffectiveOn;
        let _brandId;
        let _timer;
        let _inMaintenanceMode = false;
        const MAINTENANCE_STATUS = {
            IN_MAINTENANCE : 'IN_MAINTENANCE',
            OUT_OF_MAINTENANCE : 'OUT_OF_MAINTENANCE'
        };

        const POST_MAINTENANCE_ACTION = {
            REVOKE_SESSION : 'REVOKE_SESSION'
        };
        self.init = function (brandId) {
            _brandId = brandId;
            lastEffectiveOn = null;
            if (typeof (buildVersion) != "undefined") {
                _currentActiveVersion = parseInt(buildVersion);
                doVersionCheck();
            }
        };

        var doVersionCheck = function () {

            $timeout.cancel(_checkTimerPromise);

            if (!_currentActiveVersion) {
                return;
            }

            _lastCheck = Date.now();

            VersionManagerAPI.loadWebVersion(_currentActiveVersion, _brandId)
                .then(async function (res) {
                    clearTimeout(_timer);

                    if (!isNaN(parseInt(res.api_pulling_frequency))) {
                        _checkFrequency = parseInt(res.api_pulling_frequency) * 1000;
                    }

                    if (res?.maintenance?.status === MAINTENANCE_STATUS.IN_MAINTENANCE) {
                        _inMaintenanceMode = true;
                        $state.go('maintenance', {}, {reload: true});
                        return;
                    }

                    if (res?.maintenance?.status === MAINTENANCE_STATUS.OUT_OF_MAINTENANCE) {
                        const loginTime = await hLoginManager.getLoginTime();
                        if (res.maintenance.post_maintenance_action === POST_MAINTENANCE_ACTION.REVOKE_SESSION) {
                            if (!loginTime || moment(loginTime).isBefore(moment(res.maintenance.post_maintenance_action_time))) {
                                hUser.logout();
                                hLoginManager.signOut();
                                return;
                            }
                        }
                        if (_inMaintenanceMode) {
                            hRedirect('/');
                        }
                    }
                    if (res?.cache_config?.invalidation?.effective_on) {
                        if (moment(res.cache_config.invalidation.effective_on).isSameOrBefore(moment())){
                            if (initialized && !moment(res.cache_config.invalidation.effective_on).isSame(lastEffectiveOn)) {
                                activateVersionUpdate(true, true);
                            }
                            lastEffectiveOn = moment(res.cache_config.invalidation.effective_on);
                        } else if (moment(res.cache_config.invalidation.effective_on).isAfter(moment())) {
                            _timer = setTimeout(function () {
                                activateVersionUpdate(true, true);
                            }, moment(res.cache_config.invalidation.effective_on).diff(moment()))
                        }
                    }

                    if (initialized && res && res['version'] > _currentActiveVersion && moment(res['effective_on']).isSameOrBefore(moment())) {
                        checkForRules(res)
                            .then(function (doUpdate) {
                                if (doUpdate) {
                                    $timeout.cancel(_checkTimerPromise);
                                    activateVersionUpdate(res['force_update']);
                                }
                            })
                    }
                })
                .finally(function () {
                    initialized = true;
                    _checkTimerPromise = $timeout(function () {
                        doVersionCheck();
                    }, _checkFrequency);
                });
        };

        var checkForRules = function (versionObj) {
            var defer = $q.defer();
            var rules = versionObj.rules || [];
            var doUpdate = true;
            var isAsyncCheck = false;

            for (var i in rules) {
                var rule = rules[i];

                switch (rule.type) {
                    case 'ROUTE':
                        if (rule.value !== $state.$current['name']) {
                            doUpdate = false;
                            break;
                        }
                        break;
                    case 'BRAND':
                        if (hUser.isLoggedIn() && hUser.isEmployer()) {
                            var brandId = hUser.getUserContext()['brand_id'];

                            if (brandId !== parseInt(rule.value)) {
                                doUpdate = false;
                                break;
                            }
                        }
                        else {
                            doUpdate = false;
                            break;
                        }
                        break;
                    case 'USER':
                        if (!hUser.isLoggedIn() || parseInt(rule.value) !== hUser.data.user.id) {
                            doUpdate = false;
                            break;
                        }
                        break;
                    case 'SERVICE':
                        if (!hUser.isLoggedIn() || !hUser.isEmployer()) {
                            doUpdate = false;
                            break;
                        }
                        else {
                            isAsyncCheck = true;

                            var brandId = hUser.getUserContext()['brand_id'];

                            if (!hUser.isTopLevelContext() && hUser.data.user.brands_list && hUser.data.user.brands_list.length === 1) {
                                brandId = hUser.data.user.brands_list[0].id;
                            }

                            brandServices.check(rule.value, brandId, true)
                                .then(function (isServiceEnabled) {
                                    if (!isServiceEnabled) {
                                        doUpdate = false;
                                    }

                                    defer.resolve(doUpdate);
                                });
                        }

                        break;
                    case 'URL':
                        if (rule.value !== window.location.pathname) {
                            doUpdate = false;
                            break;
                        }
                        break;
                }
            }

            if (!isAsyncCheck) {
                defer.resolve(doUpdate);
            }

            return defer.promise;
        };

        var activateVersionUpdate = function (force, redirectToHomePage) {

            let redirectURL = window.location;
            if (redirectToHomePage) {
                redirectURL = window.location.protocol + "//" + window.location.host;
            }
            if (!force) {
                Utils.hConfirm({
                    title: $filter("translate")("New Version"),
                    text: $filter("translate")("You are using an old version of Harri Web App. Would you like to refresh the page to get the latest updates?"),
                    confirmButton: $filter("translate")("Refresh"),
                    cancelButton: $filter("translate")("Keep Using Old Version"),
                    dialogClass: "modal-dialog",
                    callback: function (confirm) {
                        if (confirm) {
                            window.location = redirectURL;
                        }
                    }
                });
            }
            else {
                window.location = redirectURL;
            }
        };
    }

})();
